import React  from 'react';
import { Box, Switch, Typography } from '@mui/material';
import {  ReferenceFormRequest } from '../../../../../api/interfaces/Reference';

interface AdditionalSettingsProps {
    isSubmitting: boolean;
    formData: ReferenceFormRequest;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const AdditionalSettings: React.FC<AdditionalSettingsProps> = ({
    isSubmitting,
    formData,
    onChange
}) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
            >
                <Typography variant="body2" sx={{ color: '#818181' }}>
                    Set this reference as <Box component="span" sx={{ fontWeight: 'bold' }}>“TRIAL”</Box> mode?
                </Typography>

                <Switch
                    checked={formData.isTrial}
                    onChange={onChange}
                    disabled={isSubmitting}
                    name="isTrial"
                />
            </Box>

             <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
            >
                <Typography variant="body2" sx={{ color: '#818181' }}>
                    <Box component="span" sx={{ fontWeight: 'bold' }}>Show</Box> this reference in the list? Toggle to include or hide.
                </Typography>

                <Switch
                    checked={formData.isVisible}
                    onChange={onChange}
                    disabled={isSubmitting}
                    name="isVisible"
                />
            </Box>
        </Box>
    );
};


export default AdditionalSettings;
